import { IMAGE_MIME_SUPPORT, VIDEO_MIME_SUPPORT } from "../constants/media"

const getFileType = (file) => {
    let fileType = "other"
    if (VIDEO_MIME_SUPPORT.includes(file.mime)) fileType = "video"
    if (IMAGE_MIME_SUPPORT.includes(file.mime)) fileType = "image"
    return fileType
}

export default getFileType